import React from "react";
import {
  Box,
  Chip,
  Tooltip,
  Typography,
} from "components/mui";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { calculateBase64Size } from "libs/utils/fileUtils";
import { formatFileSize } from "utils/formatFileSize";

/**
 * The chip list of attachments currently on the email.
 *
 * In edit mode the chips are not individually deletable — attachments are managed
 * through `AttachmentModal`, which returns the complete desired list.
 */
function AttachmentBar({ attachments, editMode, onPreview, onRemoveAt }) {
  if (attachments.length === 0) return null;

  return (
    // Plain Box: this sits directly in the page, not inside a <Grid container>, so a
    // `Grid item` here was invalid MUI usage (Bug #7).
    <Box sx={{ my: 2 }}>
      <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
        Attachments ({attachments.length})
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
        {attachments.map((attachment, index) => {
          const sizeBytes = attachment.data ? calculateBase64Size(attachment.data) : 0;
          const sizeDisplay = formatFileSize(sizeBytes);

          return (
            <Tooltip key={index} title={`Click to preview • ${sizeDisplay}`} arrow>
              <Chip
                label={`${attachment.name} (${sizeDisplay})`}
                onDelete={
                  editMode
                    ? undefined // In edit mode, manage via modal
                    : () => onRemoveAt(index)
                }
                onClick={() => onPreview(attachment)}
                icon={<AttachFileIcon />}
                sx={{ cursor: "pointer" }}
              />
            </Tooltip>
          );
        })}
      </Box>
    </Box>
  );
}

export default AttachmentBar;
